import format from 'date-fns/format/index.js';
import { strMap, find, findIndex, map, html, sel, go, sortBy } from 'fxjs/es';
import { getAvailableColors, getProductStatus } from '../../../../../../Creator/Setting/S/fs.js';
import { GoodsTypeS } from '../../../../../../GoodsType/S/Function/module/GoodsTypeS.js';
import { isNeedPreview } from '../../../../../../Maker/S/categorize.js';
import { NessLabsS } from '../../../../../../NessLabs/S/Function/module/NessLabsS.js';
import { PriceS } from '../../../../../../Price/S/Function/module/PriceS.js';
import { creatorPriceOfProduct } from '../../../../../../ProductColorPrice/S/fs.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { commify, differenceTimeInUnits } from '../../../../../../Util/S/Function/util.js';
import { MShopCoreTmplS } from '../../../../../Core/S/Tmpl/module/MShopCoreTmplS.js';
import { MShopUtilConstantS } from '../../../../../Util/S/Constant/module/MShopUtilConstantS.js';
import { MShopAppTokenGateStoresProductTmplS } from '../../../../TokenGate/StoresProduct/S/Tmpl/module/MShopAppTokenGateStoresProductTmplS.js';
import { messages } from '../../message_id.js';
import { MShopStudioPreDiscountProductS } from '../../../../../Studio/PreDiscountProduct/S/Function/module/MShopStudioPreDiscountProductS.js';
import { PRODUCT_STATUS, PRODUCT_STATUS_TEXT } from '../../constant.js';
import { isStoreProductCustomLevelUser } from '../../../../../../Creator/Product/S/fs.js';
import {
  makeFormSubmitBtnInfo,
  makeNotiHtml,
  makeProductSellingTimeHtml,
  makeRadioOptions,
  makeSizeGuideHtml,
  submitDisabledBtn,
} from './productDetailForm.js';
import { NessLabsFrameS } from '@modules/NessLabs/Frame/S';

const getByLang = (key, obj) => sel(key + _en, obj);

export const makeProductInfoHtmlNess = ({ product_detail, is_seller, need_tilde_currency, is_mobile }) => {
  const {
    _: { base_product, stores_product, selected_option_group },
    is_public,
    ['name' + _en]: prod_name,
  } = product_detail;

  const { is_use_creator, is_use_creator_en, is_use_creator_jp } = base_product;
  const base_name = base_product['name_creator' + G._en] ?? base_product['name' + G._en];
  const {
    is_prohibited,
    is_confirmed,
    is_confirm_req,
    is_check_design,
    goods_type_id,
    custom_level,
    _: { digital_product },
  } = stores_product;

  const product_status = getProductStatus({
    is_prohibited,
    is_public,
    is_confirmed,
    is_confirm_req,
    is_digital_product: !!digital_product?.id,
    is_check_design,
    is_use_creator,
    is_use_creator_en,
    is_use_creator_jp,
  });

  const status_text = [PRODUCT_STATUS.PUBLIC].includes(product_status)
    ? ''
    : `(${T(PRODUCT_STATUS_TEXT[product_status])})`;

  const creator_price = creatorPriceOfProduct(product_detail);
  const selected_opt_name = selected_option_group ? selected_option_group['title' + _en] : '';
  const bp_name = base_name + (selected_opt_name ? ` - ${selected_opt_name}` : '');
  const is_ness_bp_frame = NessLabsFrameS.NessFrameProduct.isFrameBp(base_product);
  // 할인금액
  const pre_discount_price = sel('_.pre_discount_product.pre_discount_price', product_detail);
  const pre_discount_rate = pre_discount_price
    ? MShopStudioPreDiscountProductS.calcDiscountedRateByPercent(pre_discount_price, creator_price)
    : null;

  // 할인률 없을 때
  const no_discount_price = () => {
    if (MShopStudioPreDiscountProductS.isPreProductDiscountSupported()) {
      return `<span class="pd-product__price-number mp_currency" has_tilde="${need_tilde_currency}">${UtilS.commify(creator_price)}</span>`;
    }
    return `
      <span class="pd-product__price-number">
        ${UtilS.commify(creator_price)}
      </span>
    `;
  };

  // 할인률 있을 때
  const discount_price = () => {
    return `
      <span class="pd-product__discount-rate">${pre_discount_rate}%</span>
      <span class="pd-product__price-number mp_currency">${UtilS.commify(creator_price)}</span>
      <span class="pd-product__price-number--deprecated mp_currency">
        <span>${UtilS.commify(pre_discount_price)}</span>
      </span>
    `;
  };

  const is_mps = GoodsTypeS.isMps(goods_type_id);
  const is_custom_level_user = isStoreProductCustomLevelUser(custom_level);

  return html`
    <div class="pd-product">
      ${UtilS.htmlIf(
        is_custom_level_user || is_mps,
        html`
          <div class="pd-product__badges">
            <div class="pd-product__product_type">${ET('ness::product::custom')}</div>
            ${is_custom_level_user
              ? html`
                  <div class="pd-product__product_type ${NessLabsS.getProductBadge(product_detail).type}">
                    ${NessLabsS.getProductBadge(product_detail).badge}
                  </div>
                `
              : ''}
          </div>
        `,
      )}
      <div class="pd-product__seller">
        <div class="pd-product__seller-top">
          <h1 class="pd-product__name pd-product__name--${T.lang}">
            ${UtilS.htmlIf(
              is_custom_level_user,
              html`<span class="pd-product__hide">내 캐릭터로 만드는 - </span>`,
            )}
            ${status_text ? `<span class='pd-product__status'>${status_text}</span>` : ''}
            ${prod_name || base_name}
          </h1>
        </div>
        ${UtilS.htmlIf2(
          selected_option_group?.title,
          () =>
            `<p class="pd-product__bp-name">${is_ness_bp_frame ? NessLabsFrameS.NessFrameProduct.frame_option.product_detail_sub_title : bp_name}</p>`,
        )}
      </div>
      ${is_seller && is_mps ? html`<h1 class="pd-product__name">[샘플주문]</h1>` : ''}
      <div class="pd-product__price">
        <input type="hidden" name="price" value="${creator_price}" />
        ${pre_discount_rate ? discount_price() : no_discount_price()}
      </div>
    </div>
  `;
};

export const makeProdLikeHtmlNess = ({ product_detail }) => {
  const {
    _: { stores_products_like },
    id: stores_product_id,
    custom_level,
  } = sel('_.stores_product', product_detail);
  const already_like = !!stores_products_like?.id;
  const is_ness_frame_bp = NessLabsFrameS.NessFrameProduct.isFrameBp(product_detail._.base_product);
  if (isStoreProductCustomLevelUser(custom_level) && !is_ness_frame_bp) {
    return '';
  }
  return html`
    <button
      type="button"
      class="pd__action-btn like${already_like ? ' active' : ''}"
      data-stores_product_id="${stores_product_id}"
    >
      ${MShopCoreTmplS.nessLikeIcon()}
    </button>
  `;
};

export const makeProdColorOptionsHtmlNess = ({ product_detail, selected_bpc }) => {
  const base_product = sel('_.base_product', product_detail);
  const base_product_colors = sel('_.base_product._.base_product_colors', product_detail);
  const store_product_colors = sel('_.stores_product._.store_product_colors', product_detail);
  const selected_bpc_id = selected_bpc.id;

  const colors = getAvailableColors(base_product_colors, store_product_colors);
  const options = go(
    colors,
    map((item) => ({
      value: item.id,
      label: item['name' + _en],
      color: item.color_code,
      color2: item.color_code2,
      is_public: item.is_public,
      is_active: item.id === selected_bpc_id,
    })),
    sortBy((item) => !item.is_active),
  );

  const use_label = isNeedPreview(base_product);
  const option_label = use_label
    ? ET('product_detail::options::preview_by_device')
    : ET('product_detail::options::color');

  return html`
    <div class="pd-field colors">
      <div class="pd-field__label ${use_label ? 'visible' : ''}">${option_label}</div>
      <div class="dynamic-html folded">
        ${makeRadioOptions({ name: 'color', type: 'color', options })}
        <button type="button" class="expand-btn"></button>
      </div>
    </div>
  `;
};

export const makeSizeOptionsHtmlNess = ({ use_size_option, selected_bpc }) => {
  if (!use_size_option) return '';
  const { base_product_sizes2, select_size_id = '' } = sel('_', selected_bpc) || {};
  const options = map((item) => {
    const price = getByLang('price', item);
    const label = item._is_not_stock
      ? ET('common::sold_out')
      : PriceS.price(price)
        ? `+${PriceS.price(getByLang('price', item))}`
        : '';
    return {
      label,
      value: item.id,
      name: getByLang('name', item),
      price: getByLang('price', item),
      disabled: item._is_not_stock,
      is_public: item.is_public,
      is_active: select_size_id == item.id,
    };
  }, base_product_sizes2);

  if (!find((opt) => opt.is_active, options)) {
    const index = findIndex((opt) => !opt.disabled, options);
    if (options[index]) options[index].is_active = true;
  }

  return html`
    <div class="pd-field size">
      <div class="pd-field__label">${ET('product_detail::options::size')}</div>
      <div>
        <div class="dynamic-html">${makeRadioOptions({ name: 'size', options })}</div>
        ${UtilS.htmlIf2(use_size_option, makeSizeGuideHtml)}
      </div>
    </div>
  `;
};

// Ness 타이머
export const makeProductSellingTimeHtmlNess = ({ day, hour, minute, second }) => {
  return `${day}D ${hour}H ${minute}M ${second}S`;
};

// 총 수량 및 금액
export const makeTotalPriceHtmlNess = ({ count = 1, product_detail, need_tilde_currency }) => {
  const tot_price =
    count * creatorPriceOfProduct(product_detail, 1, product_detail.selected_base_product_size_id);
  const price = UtilS.commify(tot_price);
  return html`
    <div class="pd-total">
      <div class="pd-total__count">${ET('product_detail::total_label', { count: UtilS.commify(count) })}</div>
      <div class="pd-total__price mp_currency dynamic-value" has_tilde="${need_tilde_currency}">${price}</div>
    </div>
  `;
};

export const makeProductQuantityHtmlNess = (possible_quantity, max_purchase_per_user, is_hide) => {
  return html`
    <div class="pd__quantity" ${is_hide ? 'style="display:none;"' : ''}s>
      <div class="pd-field counter">
        <div class="pd-field__label">Quantity</div>
        <div class="pd-counter${possible_quantity > 0 ? '' : ' pd-counter--none'}">
          <button type="button" class="pd-counter__btn down">${MShopUtilConstantS.svg.minus}</button>
          <input type="text" name="quantity" readonly class="pd-counter__current" value="${1}" />
          <button type="button" class="pd-counter__btn up">${MShopUtilConstantS.svg.plus}</button>
        </div>
      </div>
      ${UtilS.htmlIf2(
        max_purchase_per_user,
        () => `
        <div class="pd__max-purchase-per-user">
          ${MShopCoreTmplS.stockIcon()}
          ${T(messages.max_purchase_per_user, { max_purchase_per_user })}
        </div>`,
      )}
    </div>
  `;
};

/**
 * @ness-only
 * @see [상품상세 CTA 스펙](https://www.notion.so/marpple/NESS-27753281635280078c25d9762c1f6115?source=copy_link#27753281635280e4a802dc5ca6780b08)
 */
export const makeNotiHtmlNess = (props) => {
  const { product_detail, sales_info } = props;
  const {
    _: {
      stores_product: { sell_start_at, sell_end_at, custom_level },
    },
  } = product_detail;

  /**
   * @type {ProductStockDto}
   */
  const { stockInfo } = props.product_detail.nessProductDetail;

  const { has_period_limit, is_before_sale, is_after_sale } = sales_info;
  const is_start_selling = +new Date() > +new Date(sell_start_at);
  const remain_time_infos = differenceTimeInUnits(
    ['day', 'hour', 'minute', 'second', 'millisecond'],
    is_start_selling ? new Date(sell_end_at) : new Date(sell_start_at),
    new Date(),
    true,
  );

  const show_left_count =
    (isStoreProductCustomLevelUser(custom_level)
      ? stockInfo.availableStock && stockInfo.availableStock < 10
      : stockInfo.availableStock) &&
    stockInfo.displayConfig.enabled &&
    stockInfo.availableStock < stockInfo.displayConfig.underThreshold;

  if (has_period_limit || is_before_sale || show_left_count) {
    return html`
      <div class="pd-noti-wrapper">
        <div
          class="pd-noti ${is_before_sale ? 'is-before' : ''}"
          interval-count="1"
          current-mode="${has_period_limit || is_before_sale ? 'period' : 'quantity'}"
          data-has_period="${has_period_limit || is_before_sale}"
          data-has_quantity="${show_left_count}"
        >
          ${UtilS.htmlIf2(
            has_period_limit || is_before_sale,
            () => `
              <div class="pd-noti__label period" data-item_name="period_limit">
                ${
                  is_after_sale /* 판매 종료 */
                    ? MShopCoreTmplS.sandClockIcon() +
                      ET('product_detail::noti::end_of_sale', {
                        start_at: sell_start_at
                          ? format(sell_start_at, T.lang == 'kr' ? 'yyyy/MM/dd' : 'yyyy/MM/dd')
                          : '',
                        end_at: format(sell_end_at, T.lang == 'kr' ? 'yyyy/MM/dd' : 'yyyy/MM/dd'),
                      })
                    : !is_before_sale /* 출시 예정 아니면 */
                      ? MShopCoreTmplS.sandClockIcon() +
                        ET('product_detail::noti::until_close', {
                          end_at: sell_end_at,
                          remain_time: makeProductSellingTimeHtml(remain_time_infos),
                        })
                      : ET('product_detail::noti::until_open', {
                          start_at: sell_start_at,
                          end_at: new Date(),
                          remain_time: makeProductSellingTimeHtml(remain_time_infos),
                        })
                }
              </div>
            `,
          )}
          ${UtilS.htmlIf2(
            show_left_count,
            () => `
              <div class="pd-noti__label quantity" data-item_name="quantity_limit">
                ${MShopCoreTmplS.cartIcon()}
                ${ET('product_detail::noti::left', { left: commify(stockInfo.availableStock) })}
              </div>
            `,
          )}
        </div>
      </div>
    `;
  } else {
    return '';
  }
};

export const mobileSubmitDisabledNess = ({ props: { product_detail, sales_info }, btn_text }) => {
  const { is_before_sale } = sales_info;
  return html`
    <div class="pd-submit">
      <div class="pd-submit__action">${makeProdLikeHtmlNess({ product_detail })}</div>
      <div class="pd-submit__btns">
        ${UtilS.htmlIf2(
          is_before_sale,
          () => makeNotiHtml({ product_detail, sales_info }),
          () => `<button class="pd-submit__btn" disabled type="button">${btn_text}</button>`,
        )}
      </div>
    </div>
  `;
};

export const pcSubmitDisabledNess = ({ props, btn_text, is_disabled, is_digital_product }) => {
  const { product_detail, sales_info } = props;
  const { is_before_sale } = sales_info;

  return html`
    <div class="pd-submit">
      ${!is_before_sale ? makeNotiHtml({ product_detail, sales_info }) : ''}
      ${html`
        <div class="pd-submit__btns">
          ${is_before_sale ? makeNotiHtml({ product_detail, sales_info }) : submitDisabledBtn(btn_text)}
        </div>
      `}
      ${is_disabled && is_digital_product
        ? html`
            <div class="pd-submit__disabled">
              <img
                src="//s3.marpple.co/files/u_2308668/2023/7/original/0a51f2fdd47d99617b2888003f1bcdf7e87385cc1.webp"
                alt="caution icon image"
              />
              <div class="pd-submit__disabled-text">
                이미 구매한 상품으로 다운로드 가능 기간이 지나면 재구매가 가능해요.
              </div>
            </div>
          `
        : ''}
    </div>
  `;
};

// 장바구니 버튼
export const makeFormSubmitBtnNess = (props) => {
  const { is_mobile, product_detail, sales_info, isApp, store /* login_user */ } = props;
  const {
    _: { base_product, stores_product },
    is_public,
  } = product_detail;
  const {
    is_prohibited,
    is_confirmed,
    is_confirm_req,
    is_check_design,
    is_purchased_dtg = false,
    _: { digital_product, stores_products_token_gates },
  } = stores_product;

  const is_digital_product = !!digital_product?.id;

  const { can_selling /* user_id: owner_id */ } = store;
  const { is_use_creator, is_use_creator_en, is_use_creator_jp } = base_product;

  const product_status = getProductStatus({
    is_prohibited,
    is_public,
    is_confirmed,
    is_confirm_req,
    is_digital_product,
    is_check_design,
    is_use_creator,
    is_use_creator_en,
    is_use_creator_jp,
  });

  const { is_disabled, btn_text } = makeFormSubmitBtnInfo({
    can_selling,
    sales_info,
    is_digital_product,
    isApp,
    product_status,
    is_purchased_dtg,
  });

  if (is_disabled) {
    if (is_mobile) {
      return mobileSubmitDisabledNess({ props, btn_text });
    } else {
      return pcSubmitDisabledNess({ props, btn_text, is_disabled, is_digital_product });
    }
  } else if (stores_products_token_gates.length) {
    if (is_mobile) {
      return `${MShopAppTokenGateStoresProductTmplS.mobileSubmitTokenGate({
        product_detail,
        btn_text,
      })}`;
    } else {
      return `${MShopAppTokenGateStoresProductTmplS.pcSubmitTokenGate({
        stores_products_token_gates,
        btn_text,
      })}`;
    }
  } else {
    if (is_mobile) {
      return mobileSubmitNess({ props, btn_text });
    } else {
      return pcSubmitNess({ props, btn_text });
    }
  }
};

export const makeRadioOptionsNess = ({ name, type = 'value', options }) => {
  const getBorderColor = (item) => {
    if (!item.color) return '';
    let border_color = item.color;
    if (item.color.indexOf('gradient') > -1) {
      border_color = item.color.match(/(#[a-zA-Z0-9])\w+/g)[0];
    }
    return `style="border-color: ${border_color}"`;
  };
  const checkDisabled = (item) => (item.disabled ? 'disabled' : '');
  const getFaceContent = (item) =>
    (type == 'preview' &&
      `<img src="${item.preview}" alt="${item.label}" class="pd-radio__face--preview" />`) ||
    (type == 'color' &&
      `<span style="background: ${
        item.color2
          ? `linear-gradient(135deg, ${
              item.color == '#ffffff' || item.color == '#fefefe' ? '#f8f8f8' : item.color
            } 50%, ${item.color2 == '#ffffff' || item.color2 == '#fefefe' ? '#f8f8f8' : item.color2} 50%)`
          : item.color
      }" class="pd-radio__face--color"></span>`) ||
    `<span class="pd-radio__face--value">${item.name}</span>`;

  return html`
    <div class="pd-radio-group ${type}">
      ${strMap(
        (item) =>
          item.is_public
            ? html`
                <label class="pd-radio ${type} ${checkDisabled(item)}" ${getBorderColor(item)}>
                  <input
                    type="radio"
                    name="${name}"
                    ${checkDisabled(item)}
                    ${item.is_active ? 'checked' : ''}
                    data-price="${item.price || 0}"
                    value="${item.value}"
                  />
                  <span class="pd-radio__face ${type} ${checkDisabled(item)}" title="${item.label}">
                    ${getFaceContent(item)}
                  </span>
                  ${UtilS.htmlIf(
                    item.label,
                    `<span class="pd-radio__text" title="${item.label}">${item.label}</span>`,
                  )}
                </label>
              `
            : '',
        options,
      )}
    </div>
  `;
};

export const makeFormSubmitBtnInfoNess = ({
  can_selling,
  sales_info,
  is_digital_product,
  isApp,
  product_status,
  is_purchased_dtg,
}) => {
  const { is_before_sale, is_after_sale, is_sold_out, is_selling_product } = sales_info;
  const is_disabled =
    !can_selling || // 스토어의 판매상태
    is_sold_out || // 스토어 오너가 아니고, 솔드아웃인 경우
    !is_selling_product || // 스토어 오너가 아니고, 판매중이 아닌경우
    (isApp && is_digital_product) || // 디지털 상품이고, 환경이 앱인경우
    (is_digital_product && ![PRODUCT_STATUS.PUBLIC].includes(product_status)) || // 디지털상품이고, 상품의 상태가 공개중이 아닌경우
    (is_digital_product && is_purchased_dtg); // 디지털 상품이고 구매하고 7일이 지나지 않은 경우

  return go(
    void 0,
    () => {
      if (!can_selling) return ET('product_detail::not_approve');
      else if (is_sold_out) return ET('product_detail::sold_out_products');
      else if (is_before_sale) return ET('product_detail::coming_soon');
      else if (is_after_sale) return ET('product_detail::end_sale');
      else if (isApp && is_digital_product) return ET('product_detail::only_pc');
      else if (is_digital_product && is_purchased_dtg) return ET('product_detail::purchased_dtg');
      return ET('product_detail::cart');
    },
    (btn_text) => {
      return {
        is_disabled,
        btn_text,
      };
    },
  );
};

export const pcSubmitNess = ({ props, btn_text }) => {
  const { product_detail, sales_info } = props;

  return html`
    <div class="pd-submit">
      ${makeNotiHtml({ product_detail, sales_info })}
      <div class="pd-submit__btns">
        ${product_detail._.stores_product.only_buy_now
          ? ``
          : html`<button class="pd-submit__btn pd-submit__btn--cart" type="button" data-action="cart">
              ${btn_text}
            </button>`}
        <button class="pd-submit__btn" type="button" data-action="checkout">
          ${ET('product_detail::buy')}
        </button>
      </div>
    </div>
  `;
};

export const mobileSubmitNess = ({ props: { product_detail }, btn_text }) => {
  return html`
    <div class="pd-submit">
      <div class="pd-submit__action">${makeProdLikeHtmlNess({ product_detail })}</div>
      <div class="pd-submit__btns">
        <button class="pd-submit__btn pd-submit__btn--form" type="button">
          ${ET('product_detail::buy')}
        </button>
        ${product_detail._.stores_product.only_buy_now
          ? ``
          : html`<button
              style="display: none;"
              class="pd-submit__btn pd-submit__btn--cart"
              type="button"
              data-action="cart"
            >
              ${btn_text}
            </button>`}
        <button style="display: none;" class="pd-submit__btn" type="button" data-action="checkout">
          ${ET('product_detail::buy')}
        </button>
      </div>
    </div>
  `;
};

export const makeShareLikeHtmlNess = ({ product_detail }) => {
  const {
    _: { stores_products_like },
    id: stores_product_id,
    custom_level,
    like_count,
  } = sel('_.stores_product', product_detail);
  const already_like = !!stores_products_like?.id;
  return html`
    <div class="pd-share-like-ness">
      <button type="button" class="pd-share-like-ness__btn pd-share-like-ness__share pd__action-btn share">
        ${MShopCoreTmplS.nessShareIcon()}소문내기
      </button>
      ${isStoreProductCustomLevelUser(custom_level)
        ? ''
        : html`
            <div class="pd-share-like-ness__divider"></div>
            <button
              type="button"
              class="pd-share-like-ness__btn pd-share-like-ness__like pd__action-btn like${already_like
                ? ' active pd-share-like-ness__like--active'
                : ''}"
              data-stores_product_id="${stores_product_id}"
            >
              ${MShopCoreTmplS.nessLikeIcon()}좋아요<span
                class="pd-share-like-ness__like-count"
                data-like_count="${like_count}"
              >
                ${UtilS.commify(like_count)}
              </span>
            </button>
          `}
    </div>
  `;
};
